import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Euro, Clock, ArrowRight, AlertCircle } from 'lucide-react';

const positionColors = {
  GK: 'position-gk',
  DEF: 'position-def',
  MID: 'position-mid',
  FWD: 'position-fwd',
};

const positionLabels = {
  GK: 'Portera',
  DEF: 'Defensa',
  MID: 'Mediocampista',
  FWD: 'Delantera',
};

const priorityLabels = {
  high: 'Alta',
  medium: 'Media',
  low: 'Baja',
};

export const NeedCard = ({ need }) => {
  const clubLogo = `https://api.dicebear.com/7.x/identicon/svg?seed=${need.club_name}`;
  
  return (
    <Link 
      to={`/needs/${need.id}`} 
      className="need-card block group"
      data-testid={`need-card-${need.id}`}
    >
      <div className="flex items-start gap-4">
        {/* Club logo */}
        <div className="flex-shrink-0">
          <img
            src={clubLogo}
            alt={need.club_name}
            className="w-14 h-14 rounded-lg bg-slate-100 p-2"
          />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-4">
            <div>
              <h3 className="font-heading font-bold text-lg text-slate-800 tracking-tight">
                {need.club_name}
              </h3>
              <p className="text-sm text-slate-500">
                {need.club_league} • {need.club_country}
              </p>
            </div>

            {/* Priority badge */}
            <span className={`badge-need badge-priority-${need.priority}`}>
              {priorityLabels[need.priority]}
            </span>
          </div>

          {/* Position needed */}
          <div className="mt-4 flex items-center gap-3">
            <span className={`position-badge text-xs ${positionColors[need.position]}`}>
              {need.position}
            </span>
            <span className="font-heading font-semibold text-slate-700 uppercase tracking-wide">
              Busca: {positionLabels[need.position] || need.position}
            </span>
          </div>

          {/* Details */}
          <div className="mt-3 flex flex-wrap items-center gap-4 text-sm text-slate-600">
            {(need.min_age || need.max_age) && (
              <div className="flex items-center gap-1.5">
                <Clock className="w-4 h-4 text-slate-400" strokeWidth={1.5} />
                <span>
                  {need.min_age && need.max_age
                    ? `${need.min_age}-${need.max_age} años`
                    : need.min_age
                    ? `+${need.min_age} años`
                    : `-${need.max_age} años`}
                </span>
              </div>
            )}

            {need.budget && (
              <div className="flex items-center gap-1.5">
                <Euro className="w-4 h-4 text-indigo-500" strokeWidth={1.5} />
                <span className="font-semibold text-slate-800">
                  Hasta {new Intl.NumberFormat('es-ES', {
                    style: 'currency',
                    currency: 'EUR',
                    maximumFractionDigits: 0,
                  }).format(need.budget)}
                </span>
              </div>
            )}

            <div className="flex items-center gap-1.5">
              <span className={`text-xs uppercase tracking-wider font-medium ${
                need.type === 'transfer' ? 'text-lime-600' :
                need.type === 'loan' ? 'text-amber-600' : 'text-indigo-600'
              }`}>
                {need.type === 'transfer' ? 'Transferencia' :
                 need.type === 'loan' ? 'Préstamo' : 'Ambos'}
              </span>
            </div>
          </div>

          {need.description && (
            <p className="mt-3 text-sm text-slate-500 line-clamp-2">
              {need.description}
            </p>
          )}

          {/* Footer */}
          <div className="mt-4 flex items-center justify-between pt-3 border-t border-slate-100">
            <span className="text-xs text-slate-400 uppercase tracking-wider">
              Ver detalles
            </span>
            <ArrowRight className="w-4 h-4 text-indigo-500 group-hover:translate-x-1 transition-transform" strokeWidth={1.5} />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default NeedCard;
